import React from 'react';
import { PublicationConfirmationFeature } from './publicationConfirmation';

export const StepThree: React.FC = () => (
  <React.Fragment>
    <PublicationConfirmationFeature />
  </React.Fragment>
);
